export default "__VITE_ASSET__68c35ed0__"